import React from 'react';
import { string, bool, func, node } from 'prop-types';
import classNames from 'classnames';
import styles from './DesktopMenuItem.scss';
import notifyAnalytics from '../notify-analytics';
import formatTestId from '../../../utils/test-id/format-testid';
import offersCategoryDesktop, {
  blackFridayCategory,
} from '../offers-category-desktop';

const DesktopMenuItem = ({
  label,
  url,
  active,
  onClose,
  onSelect,
  isTouch,
  isBrandPromiseActive,
  children,
}) => {
  const isOffer = offersCategoryDesktop(label);
  const isBlackFriday = blackFridayCategory(label);
  const handleKeyDown = e => {
    if (e.key !== 'Enter') return;

    if (children) {
      e.preventDefault();
      (active ? onClose : onSelect)();
    } else {
      notifyAnalytics(label);
    }
  };

  const handleOnClick = e => {
    if (!active && children) {
      e.preventDefault();
      onSelect();
    } else {
      notifyAnalytics(label);
    }
  };

  const eventHandlers = {
    onMouseOver: onSelect,
    onMouseLeave: onClose,
    onKeyDown: handleKeyDown,
  };

  const cn = classNames(styles.desktopMenuItem, {
    [styles.desktopMenuItem__active]: active,
    [styles.desktopMenuItem__bp]: isBrandPromiseActive,
  });

  return (
    // eslint-disable-next-line
    <li
      className={cn}
      {...(!isTouch && { ...eventHandlers })}
      data-testid={formatTestId(label, 'nav-')}
    >
      <a
        className={classNames(styles.desktopMenuItemLink, {
          [styles.offersLabel]: isOffer || isBlackFriday,
        })}
        href={url}
        onClick={handleOnClick}
      >
        {label}
      </a>
      {active && children}
    </li>
  );
};

DesktopMenuItem.defaultProps = {
  children: undefined,
  isBrandPromiseActive: false,
};

DesktopMenuItem.propTypes = {
  label: string.isRequired,
  url: string.isRequired,
  active: bool.isRequired,
  onSelect: func.isRequired,
  onClose: func.isRequired,
  isTouch: bool.isRequired,
  isBrandPromiseActive: bool,
  children: node,
};

export default DesktopMenuItem;
